import { Box, BoxProps } from "@chakra-ui/react";
import DOMPurify from "dompurify";
import "./styles.css";

interface EmbeddedHtmlProps extends BoxProps {
  innerHtml: string;
  /** Render headings at email-client sizes — use when displaying email bodies. */
  emailHeadingSizes?: boolean;
}

export default function EmbeddedHtml({ innerHtml, emailHeadingSizes = false, ...rest }: EmbeddedHtmlProps) {
  const sanitizedHtml = () => ({
    __html: DOMPurify.sanitize(innerHtml),
  });

  const className = emailHeadingSizes ? "embedded-html email-heading-sizes" : "embedded-html";
  return <Box className={className} dangerouslySetInnerHTML={sanitizedHtml()} {...rest} />;
}
